import TeacherPicture from './TeacherPicture';

export default TeacherPicture;
